import * as yup from 'yup'

// "Outro" só quando a IA é digitada manualmente (isOther sem id). Uma IA "Outro"
// já salva tem id e é tratada como ferramenta conhecida — mesma regra usada no
// GeneralInfo (render dos campos) e no buildGeneralInfoPayload (montagem do envio).
const isOtherTool = (tool) => !!tool?.isOther && !tool?.id

export const generalInfoSchema = yup.object({
  selectedTool: yup.object().nullable().required(),
  toolName: yup.string().when('selectedTool', {
    is: isOtherTool,
    then: yup.string().required().max(255),
    otherwise: yup.string().nullable(),
  }),
  providerName: yup.string().when('selectedTool', {
    is: isOtherTool,
    then: yup.string().required().max(255),
    otherwise: yup.string().nullable(),
  }),
  department: yup.array().min(1, 'Selecione ao menos um departamento'),
  description: yup.string().max(2000).nullable(),
  operationMode: yup.string().required('Selecione o tipo de operação'),
  humanIntervention: yup
    .string()
    .required('Informe se há intervenção humana obrigatória'),
  processesPersonalData: yup
    .string()
    .oneOf(['yes', 'no'], 'Informe se a IA utiliza dados pessoais'),
})

export const guestGeneralInfoSchema = yup.object({
  selectedTool: yup.object().nullable().required(),
  toolName: yup.string().when('selectedTool', {
    is: isOtherTool,
    then: yup.string().required().max(255),
    otherwise: yup.string().nullable(),
  }),
  providerName: yup.string().when('selectedTool', {
    is: isOtherTool,
    then: yup.string().required().max(255),
    otherwise: yup.string().nullable(),
  }),
  description: yup.string().max(2000).nullable(),
  operationMode: yup.string().required('Selecione o tipo de operação'),
  humanIntervention: yup
    .string()
    .required('Informe se há intervenção humana obrigatória'),
  processesPersonalData: yup
    .string()
    .oneOf(['yes', 'no'], 'Informe se a IA utiliza dados pessoais'),
})
